// src/config/api.js

export const BASE_URL = "https://pbhrm.com/api/";

export const IMG_URL = "https://pbhrm.com/";
